import {JsonProperty} from '@hyperloris/tyson';
import {SyncMetadata} from "./sync-metadata";

export class RecordResult<T = any> {

  @JsonProperty()
  success: boolean = false;

  @JsonProperty()
  message: string = '';

  @JsonProperty()
  records: T[];

  @JsonProperty()
  syncMetadata?: SyncMetadata

}

